import { z } from "zod";

import {
  EQUAL_PASSWORD_MESSAGE,
  MIN_LENGTH_MESSAGE,
  PASSWORD_RULE_MESSAGE,
} from "@/utils/validation-messages";

export const resetPasswordSchema = z
  .object({
    password: z
      .string()
      .min(6, { message: MIN_LENGTH_MESSAGE("6") })
      .regex(/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{6,}$/, {
        message: PASSWORD_RULE_MESSAGE,
      }),
    confirmPassword: z.string().min(6, { message: MIN_LENGTH_MESSAGE("6") }),
    token: z.string().optional(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: EQUAL_PASSWORD_MESSAGE,
    path: ["confirmPassword"],
  });
